// extracted by mini-css-extract-plugin
module.exports = {"finishView":"styles_finishView__1zPVi","background":"styles_background__PUpPG","btns":"styles_btns__mfEJ0"};